import { useContext } from "react";

import { UserPreferencesContext } from "../contexts/UserPreferencesContext";

export function useUserPreferences() {
  const context = useContext(UserPreferencesContext);

  return context;
}
